import { Coins } from "lucide-react";
import { StatusBadge } from "@/components/common/StatusBadge";
import { fdate, mxn } from "@/lib/format";

const COLOR = { desembolso: "text-sky-700", pago: "text-emerald-700", devolucion: "text-amber-700" };

// Build 3 · Perfil 360: movimientos de la operación de factoraje y su remanente pendiente.
export function FactorajeMovimientos({ credito, testid }) {
  const movs = credito?.movimientos_factoraje || [];
  const rem = credito?.remanente || {};
  return (
    <section className="mb-5" data-testid={testid}>
      <h4 className="mb-2 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-primary">
        <Coins className="h-3.5 w-3.5" /> Factoraje · {credito.numero_credito} · {credito.estatus_operacion || credito.estatus}
      </h4>
      <div className="mb-2 grid grid-cols-3 gap-2 text-sm">
        {[["Remanente generado", rem.generado], ["Devuelto", rem.devuelto], ["Remanente pendiente", rem.pendiente]].map(([l, v]) => (
          <div key={l} className="rounded-md border border-slate-200 bg-slate-50 p-2" data-testid={`${testid}-${l.toLowerCase().replace(/\s+/g, "-")}`}>
            <p className="text-[10px] uppercase tracking-wide text-slate-500">{l}</p>
            <p className="font-semibold tabular-nums text-slate-800">{mxn(v || 0)}</p>
          </div>
        ))}
      </div>
      <div className="overflow-x-auto rounded-md border border-slate-200">
        <table className="w-full text-left text-xs" data-testid={`${testid}-tabla`}>
          <thead className="bg-slate-50 uppercase tracking-wide text-slate-500">
            <tr><th className="px-2 py-1.5">Fecha</th><th className="px-2 py-1.5">Movimiento</th><th className="px-2 py-1.5 text-right">Monto</th>
              <th className="px-2 py-1.5 text-right">Aplicado</th><th className="px-2 py-1.5 text-right">Remanente</th>
              <th className="px-2 py-1.5">Referencia</th><th className="px-2 py-1.5">Estatus</th></tr>
          </thead>
          <tbody>
            {movs.map((m, i) => (
              <tr key={`${m.tipo}-${m.referencia}-${i}`} className="border-t border-slate-100" data-testid={`${testid}-mov-${m.tipo}-${i}`}>
                <td className="px-2 py-1.5">{fdate(m.fecha)}</td>
                <td className={`px-2 py-1.5 font-medium ${COLOR[m.tipo]}`}>{m.concepto}{m.pagador ? ` · ${m.pagador}` : ""}</td>
                <td className="px-2 py-1.5 text-right font-mono tabular-nums">{mxn(m.monto)}</td>
                <td className="px-2 py-1.5 text-right font-mono tabular-nums">{m.tipo === "pago" ? mxn(m.aplicado) : "—"}</td>
                <td className="px-2 py-1.5 text-right font-mono tabular-nums">{m.tipo === "pago" ? mxn(m.remanente) : "—"}</td>
                <td className="px-2 py-1.5 font-mono">{m.referencia || "—"}</td>
                <td className="px-2 py-1.5"><StatusBadge value={m.estatus} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
